module.exports = __webpack_public_path__ + "img/table-empty.adc20c0d.svg";